// extracted by mini-css-extract-plugin
module.exports = {"left":"styles_left__22K2M","up":"styles_up__2Rxkq","right":"styles_right__1kqrW"};